import {Assessable, AssessableItem, ChecklistItemType} from "@models";
import {GeneratedTypePredicates} from "@services";

export enum AssessablePanelType {
	Assessment = "Assessment",
	Checklist = "Checklist",
}

export enum AssessablePanelMode {
	Edit = "Edit",
	View = "View",
	Answer = "Answer",
}

export const UNGROUPED_ITEMS_GROUP_ID = "ungroupedItems";

/*
 * Check if the group is active based on the activation condition
 * @param groupId The group id
 * @param assessable The assessable object, required to have the latest data from the form.
 */
export function isAssessableGroupActive(groupId: string, assessable: Assessable<AssessableItem>) {
	const group = assessable.assessableGroups.find((g) => g.groupId === groupId);
	if (!group) {
		return true;
	}

	const activationCondition = group.activationCondition;
	if (!activationCondition || !GeneratedTypePredicates.isUserRecordingAssessment(assessable)) {
		return true;
	}

	const activatingItem = assessable.assessableGroups
		.flatMap((g) => g.items)
		.find((i) => i.assessableItemId === activationCondition.activationItemId);
	if (!activatingItem) {
		return true;
	}

	switch (activatingItem.type) {
		case ChecklistItemType.ThreeStarOption:
			return activatingItem.answer >= activationCondition.activationItemAnswer;

		case ChecklistItemType.MultipleChoiceOption:
			const answer = activatingItem.answer as number[];
			const activationItemAnswer = activationCondition.activationItemAnswer as number[];
			return (
				answer != null &&
				activationItemAnswer != null &&
				answer.length === activationItemAnswer.length &&
				answer.every((a) => activationItemAnswer.includes(a))
			);

		case ChecklistItemType.FreeAnswerOption:
			return activatingItem.answer === activationCondition.activationItemAnswer;
		case ChecklistItemType.SingleChoiceOption:
			return activatingItem.answer === activationCondition.activationItemAnswer;
		case ChecklistItemType.YesNoOption:
			return activatingItem.answer === activationCondition.activationItemAnswer;
	}
}
